export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17 13a5 5 0 110 10 5 5 0 010-10zm0 6.5a1 1 0 100 2 1 1 0 000-2zm-.75-1.5h1.5v-3h-1.5v3z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.5 4a3 3 0 013 3v5h-2v-1.5h-17V17a1 1 0 001 1H10v2H4.5a3 3 0 01-3-3V7a3 3 0 013-3h15zm-15 2a1 1 0 00-1 1v1.5h17V7a1 1 0 00-1-1h-15z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};